<script setup lang="ts">
import { useRouter } from '@/composables/useRouter';
const router = useRouter();

const props = defineProps<{
  path: Array<{ title: string; route: string }>;
}>();

function handleClick(route: string) {
  if (route && route !== router.currentRoute.value.path) {
    router.push(route);
  }
}
</script>

<template>
  <div class="uk-flex uk-margin-medium-bottom">
    <h6
      v-for="(item, idx) in props.path"
      :key="item.title"
      @click="handleClick(item.route)"
      class="uk-text-bold breadcrumb"
    >
      {{ item.title }}
      <i v-if="idx < props.path.length - 1" uk-icon="triangle-right"></i>
    </h6>
  </div>
</template>

<style lang="scss">
.breadcrumb {
  cursor: pointer;
  margin: 0 !important;
  margin-right: 5px !important;
  display: inline-flex;
  align-items: center;
}
</style>
